<div style="display:block;padding-top:10px;">
<app-data-table [columns]="tableColumns" [value]="credentials" [sortField]="DefaultSortField" [rightCaptionTemplate]="credentialRightCaption" [disableSearch]="true">
  <ng-template #credentialRightCaption pTemplate="caption">
    <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Credential"
            pTooltip="Make New Credential" tooltipPosition="top"
            (click)="onClickAddCredential()">
    </button>
  </ng-template>
  <ng-template #credentialAction let-row="row">
    <button pButton type="button" class="icon-action" icon="fa fa-pencil"
            pTooltip="Update" tooltipPosition="top"
            (click)="onClickEditCredential(row)">
    </button>
    <button pButton type="button" class="icon-negative" icon="fa fa-trash"
            pTooltip="Delete" tooltipPosition="top"
            (click)="onClickDeleteCredential(row)">
    </button>
  </ng-template>

</app-data-table>
</div>
<p-confirmDialog></p-confirmDialog>

<p-dialog *ngIf="credentialToEdit&&displayDialog"
          [(visible)]="displayDialog" header="Credential" [dismissableMask]="true" [responsive]="true" [modal]="true" [resizable]="false" [style]="PrimeNgConfig.DialogStyle40">
  <form class="p-grid" #dialogForm="ngForm">

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Credential Type*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="credentialType" [placeholder]="Validation.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="credentialTypeDropDown"
                  [(ngModel)]="credentialToEdit.type" required></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Degree Major*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="degreeMajor" [placeholder]="Validation.DropdownPlaceholder"
                  [style]="{ 'overflow': 'visible', 'width': '100%'}" [options]="degreeMajorDropDown"
                  [(ngModel)]="credentialToEdit.degreeMajor"
                  required [filter]="true"></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Certification Status</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="status" [placeholder]="Validation.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                  [options]="credentialStatusTypeDropDown"
                  [(ngModel)]="credentialToEdit.status"></p-dropdown>
    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label>Credential Granted*</label>
    </div>
    <div class="p-col-12 p-md-8 p-lg-8">
      <p-dropdown name="credentialGranted" [placeholder]="Validation.DropdownPlaceholder"
                  [style]="{ 'overflow': 'visible', 'width': '100%'}" [options]="credentialGrantedDropDown"
                  [(ngModel)]="credentialToEdit.credentialGranted"
                  required [filter]="true"></p-dropdown>
    </div>
    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Granting Institution*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="grantingInstitution" type="text" [maxlength]="Validation.GrantingInstitutionMaxLength"
                 [(ngModel)]="credentialToEdit.grantingInstitution" required/>
          <div *ngIf="credentialToEdit?.grantingInstitution?.length >= Validation.GrantingInstitutionMaxLength" class="alert alert-danger" style="width:225px;">
            {{Validation.MaxNumOfCharsExceeded}}
          </div>
        </div>
      </div>
    </div>
    <div class="p-col-12">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Granted On*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar name="grantedOn" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxDobEndOn" icon="fa fa-calendar" showIcon="true"
                      [(ngModel)]="credentialToEdit.credentialGrantedOn" required [monthNavigator]="true" [yearNavigator]="true"
                      [yearRange]="CredentialYearRange"
                      readonlyInput="true"></p-calendar>
        </div>
      </div>
    </div>
  </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <!-- disable it until all required field including chargeCodeId are selected -->
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="displayDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add"
              (click)="onClickSaveCredential(credentialToEdit)" [disabled]="!dialogForm.form.valid"></button>

    </div>
  </p-footer>
</p-dialog>
